import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    document.body.classList.add('overflow-hidden')
  }
  
  disconnect() {
    this.unlock()
  }
  
  unlock() {
    document.body.classList.remove('overflow-hidden')
  }
} 